import api from "@/lib/api";

/**
 * Persist a value to the autocomplete history collection.
 * Fire-and-forget: never throws so it can't block form submission.
 *
 * @param {string} field - namespacing key e.g. "sj.client_name", "po.material_name"
 * @param {string|number} value - the value to remember
 */
export async function recordHistory(field, value) {
  const v = (value == null ? "" : String(value)).trim();
  if (!field || !v) return;
  try {
    await api.post("/input-history", { field, value: v });
  } catch {
    // Swallow — autocomplete history is best-effort
  }
}

/**
 * Persist many (field, value) pairs in parallel. Use after a successful submit.
 *
 * @param {Array<{field: string, value: any}>} pairs
 */
export async function recordHistoryMany(pairs) {
  if (!Array.isArray(pairs) || pairs.length === 0) return;
  await Promise.all(pairs.map(({ field, value }) => recordHistory(field, value)));
}
